import { useCallback, useState } from "react";

import type { FlatNode } from "screens/call/callscript-graph-to-nested";
import { SocketCuePayload } from "hooks/use-cues";

import styles from "./index.module.css";
import { CallComplianceMissed } from "./call-compliance-missed";
import { CallCues } from "./call-cues";

type CallDetailsProps = {
  missedCompliance: FlatNode[];
  triggered: Array<SocketCuePayload>;
  isListenerMode: boolean;
};

export const CallDetails = ({ missedCompliance, triggered, isListenerMode }: CallDetailsProps) => {
  const [openIds, setOpenIds] = useState<Set<string>>(() => new Set([]));

  const toggleIsOpen = useCallback((id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  return (
    <div className={styles.card}>
      <h3>Call Details</h3>
      <div className={styles.accordion}>
        {!isListenerMode && (
          <CallComplianceMissed
            isOpen={openIds.has("compliance")}
            toggleIsOpen={toggleIsOpen}
            missedCompliance={missedCompliance}
            disabled={missedCompliance.length === 0}
          />
        )}
        <CallCues isOpen={openIds.has("cues")} toggleIsOpen={toggleIsOpen} triggered={triggered} />
      </div>
    </div>
  );
};
